import { Component } from '@angular/core';

/**
 * Generated class for the OutdoorsIconComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'outdoors-icon',
  templateUrl: 'outdoors-icon.html'
})
export class OutdoorsIconComponent {

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/components/icons/outdoors-icon/outdoors-icon.ts